import axios from "axios";
import React, {useEffect, useState} from "react";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import Swal from "sweetalert2";
import {baseUrl, ipAddress, userName} from '../Univ';
function AddLandRequirement() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const userId = localStorage.getItem("user_id");
    const [ownerId, setOwnerId] = useState(null);
    const [formData, setFormData] = useState({
        crop_type: "",
        land_size: "",
        land_unit: "acre",
        location: "",
        pincode: "",
        required_date: "",
        budget: ""
    });
    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };
    useEffect(() => {
        axios.get(baseUrl + "landowner-profile/" + userId + "/")
            .then((res) => {
                if (res.data.length > 0) {
                    setOwnerId(res.data[0].id);
                }
            });
    }, []);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = () => {
        setLoading(true);
        axios.get(baseUrl + "landowner-req/")
            .then((res) => {
                console.log("Requirements:", res.data);
                setRows(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };
    const formSubmit = (e) => {
        e.preventDefault();
        if (!userId) {
            Swal.fire("Error", "User not logged in", "error");
            return;
        }
        if (!formData.crop_type || !formData.land_size) {
            Swal.fire("Error", "Fill required fields", "error");
            return;
        }
        if (!ownerId) {
            Swal.fire("Error", "Land owner profile not found", "error");
            return;
        }
        const fd = new FormData();
        fd.append("crop_type", formData.crop_type);
        fd.append("owner", ownerId);
        fd.append("land_size", formData.land_size);
        fd.append("land_unit", formData.land_unit);
        fd.append("location", formData.location);
        fd.append("pincode", formData.pincode);
        fd.append("required_date", formData.required_date);
        fd.append("budget", formData.budget);
        fd.append("status", "1");
        fd.append("addedby", userName);
        fd.append("ip_add", ipAddress);
        axios.post(baseUrl + "requirements/", fd)
            .then(() => {
                Swal.fire("Success", "Requirement Posted", "success");
                window.location.reload();
                setFormData({
                    crop_type: "",
                    land_size: "",
                    land_unit: "acre",
                    location: "",
                    pincode: "",
                    required_date: "",
                    budget: ""
                });
            })
            .catch((err) => {
                console.log(err.response?.data);
                Swal.fire("Error", "Something went wrong", "error");
            });
    };
    const columns = [
        {field: "id", headerName: "ID", width: 80},
        {field: "crop_type", headerName: "Crop", width: 150},
        {field: "land_size", headerName: "Size", width: 120},
        {field: "land_unit", headerName: "Unit", width: 120},
        {field: "location", headerName: "Location", width: 200},
        {field: "pincode", headerName: "Pincode", width: 120},
        {field: "budget", headerName: "Budget", width: 120},
        {field: "pincode", headerName: "Pincode", width: 120},
        {
            field: "delete",
            headerName: "Action",
            width: 100,
            renderCell: (params) => (
                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(params.row.id)}
                >
                    Delete
                </button>
            )
        }
    ];
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-requirements/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">

            {/* FORM */}
            <div className="card">
                <h4 className="card-header">Post Land Requirement</h4>

                <div className="card-body">

                    <input name="crop_type" placeholder="Crop Type"
                           className="form-control mb-2"
                           onChange={handleChange}/>

                    <input name="land_size" placeholder="Land Size"
                           className="form-control mb-2"
                           onChange={handleChange}/>

                    <select name="land_unit"
                            className="form-control mb-2"
                            onChange={handleChange}>
                        <option value="acre">Acre</option>
                        <option value="cent">Cent</option>
                    </select>

                    <input name="location" placeholder="Location"
                           className="form-control mb-2"
                           onChange={handleChange}/>

                    <input name="pincode" placeholder="Pincode"
                           className="form-control mb-2"
                           onChange={handleChange}/>

                    <input type="date"
                           name="required_date"
                           className="form-control mb-2"
                           onChange={handleChange}/>

                    <input name="budget" placeholder="Budget"
                           className="form-control mb-2"
                           onChange={handleChange}/>

                    <button onClick={formSubmit} className="btn btn-primary">
                        Submit
                    </button>

                </div>
            </div>

            {/* TABLE */}
            <ERPDataGrid
                sx={{
                    boxShadow: 4,
                    border: 4,
                    borderColor: 'primary.light',
                    '& .MuiDataGrid-cell:hover': {
                        color: 'primary.main',
                    },
                }}
                className="mt-4"
                rows={rows}
                columns={columns}
                loading={loading}

                autoHeight
            />

        </section>
    );
}
export default AddLandRequirement;
